module.exports = __webpack_public_path__ + "img/tf23.2dec82f7.png";